export const headerData = {
  name: "Hager Khaled",
  title: "Hello! I am",
  desciption:
    "Hello! I am Hager Khaled, a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am Passionate about Open source technologies. ",
  image: "https://i.ibb.co/ZmdNH6x/abu-said.jpg",
  imagebw: "https://i.ibb.co/Cw2Xp90/abu-said-bw.jpg",
  resumePdf:
    "https://docs.google.com/document/d/1Lo2SIyjvuTdHzxolupWPq1M2cleTTmOU/edit?usp=sharing&ouid=106154164085196794270&rtpof=true&sd=true",
};
